import { useContainer } from "#imports";
import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import ProfileMapper from "~~/package/mapper/profile/ProfileMapper";
import { ProfileModel } from "~~/package/mapper/profile/model/ProfileModel";
import { ProfileUserInformationModel } from "~~/package/mapper/profile/model/ProfileUserInformationModel";
import { useProfileStore } from "~~/application/store/profile/profileStore";
import {
    ProfileUserInformationWorkExperienceModel, ProfileWorkExperienceCreateModel
} from "~~/package/mapper/profile/model/ProfileUserInformationWorkExperienceModel";
import {
    ProfileEducationCreateModel,
    ProfileUserInformationEducationModel
} from "~~/package/mapper/profile/model/ProfileUserInformationEducationModel";

export const useProfileService = () => {
    const profileMapper = useContainer<ProfileMapper>(DependencyInjectId.ProfileMapper);
    const profileStore = useProfileStore();

    const getUserMyProfile = async (lang: string): Promise<void> => {
        const response: ProfileModel = await profileMapper.getUserMyProfile(lang);
        profileStore.userInfo = response.userProfileVOV2;
        profileStore.assessmentList = response.assessmentVOList;
        profileStore.contestList = response.contestVOList;

        await Promise.resolve();
    }

    const getUserShareProfile = async (uuid: string, lang: string): Promise<void> => {
        const response: ProfileModel = await profileMapper.getUserShareProfile(uuid, lang);
        profileStore.userInfo = response.otherUserProfileVO;
        profileStore.assessmentList = response.assessmentVOList;
        profileStore.contestList = response.contestVOList;

        await Promise.resolve();
    }

    const getUserWorkExperienceList = async (isShare: boolean, lang: string, uuid: string): Promise<void> => {
        profileStore.workExperienceList = await profileMapper.getUserWorkExperienceList(isShare, lang, uuid);

        await Promise.resolve();
    }

    const getUserEducationList = async (isShare: boolean, lang: string, uuid: string): Promise<void> => {
        profileStore.educationList = await profileMapper.getUserEducationList(isShare, lang, uuid)

        await Promise.resolve();
    }

    const getUserSkills = (): Promise<string[]> => {
        return profileMapper.getUserSkills();
    }

    const modifyUserProfile = (profileData: ProfileUserInformationModel): Promise<ProfileUserInformationModel> => {
        return profileMapper.modifyUserProfile(profileData);
    }

    const addAboutMe = (title: string, content: string): Promise<boolean> => {
        return profileMapper.addAboutMe(title, content);
    }

    const addWorkExperience = (workExperience: ProfileWorkExperienceCreateModel): Promise<boolean> => {
        return profileMapper.addWorkExperience(workExperience);
    }

    const addEducation = (education: ProfileEducationCreateModel): Promise<boolean> => {
        return profileMapper.addEducation(education);
    }

    const modifyAboutMe = (id:number, title: string, content: string): Promise<boolean> => {
        return profileMapper.modifyAboutMe(id, title, content);
    }

    const modifyWorkExperience = (workExperience: ProfileWorkExperienceCreateModel): Promise<boolean> => {
        return profileMapper.modifyWorkExperience(workExperience);
    }

    const modifyEducation = (education: ProfileEducationCreateModel): Promise<boolean> => {
        return profileMapper.modifyEducation(education);
    }

    const deleteAboutMe = (id:number): Promise<boolean> => {
        return profileMapper.deleteAboutMe(id);
    }

    const deleteWorkExperience = (id:number): Promise<boolean> => {
        return profileMapper.deleteWorkExperience(id);
    }

    const deleteEducation = (id:number): Promise<boolean> => {
        return profileMapper.deleteEducation(id);
    }

    const profileImageUpdate = (formData: FormData): Promise<boolean> => {
        return profileMapper.profileImageUpdate(formData);
    }

    return {
        getUserMyProfile,
        getUserShareProfile,
        getUserWorkExperienceList,
        getUserEducationList,
        getUserSkills,
        modifyUserProfile,
        addAboutMe,
        addWorkExperience,
        addEducation,
        modifyAboutMe,
        modifyWorkExperience,
        modifyEducation,
        deleteAboutMe,
        deleteWorkExperience,
        deleteEducation,
        profileImageUpdate
    };
};
